export default "__VITE_ASSET__CxoyAnZA__"